module.exports = __webpack_public_path__ + "img/Talk Graphic 1 - Pitch.39dc4345.png";